import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { AppShell } from "../components/AppShell";
import { LoadingScreen } from "../components/States";
import { AlertsPage } from "../features/alerts/AlertsPage";
import { ApplicationsPage } from "../features/applications/ApplicationsPage";
import { AuditPage } from "../features/audit/AuditPage";
import { LoginPage } from "../features/LoginPage";
import { DevicesPage } from "../features/devices/DevicesPage";
import { OverviewPage } from "../features/overview/OverviewPage";
import { PoliciesPage } from "../features/policies/PoliciesPage";
import { ReportsPage } from "../features/reports/ReportsPage";
import { TasksPage } from "../features/tasks/TasksPage";
import { SettingsPage } from "../features/settings/SettingsPage";
import { resolveAdminBasePath } from "./basePath";

const adminBasePath = resolveAdminBasePath(
  window.location.pathname,
  import.meta.env.VITE_ADMIN_BASE_PATH || "/admin",
);

function ProtectedLayout() {
  const { status } = useAuth();
  if (status === "loading") return <LoadingScreen />;
  if (status === "anonymous") {
    const next = encodeURIComponent(
      window.location.pathname.replace(adminBasePath, "") || "/overview",
    );
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export function App() {
  return (
    <BrowserRouter basename={adminBasePath}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/policies" element={<PoliciesPage />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings/*" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
